import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { AppState } from 'src/reducers';
import { CampaignBanner, Campaign } from 'src/types';

export enum SotyState {
  PROMO = 'promo',
  ACTIVE = 'active',
  FINISHED = 'finished',
}

type ActiveBanners = {
  active: (CampaignBanner & { campaign: Campaign })[];
};

const selectCampaignBanners: (state: AppState) => ActiveBanners = state =>
  state.globals.campaignBanners;

export const useSotyState = () => {
  const campaignBanners = useSelector(selectCampaignBanners);

  const sotyState = useMemo(() => {
    const banner = campaignBanners.active.find(b => b.campaign.type === 'SOTY');

    switch (banner?.type) {
      case 'SOTY_PROMO':
        return SotyState.PROMO;
      case 'SOTY_FINISHED':
        return SotyState.FINISHED;
      case 'SOTY_ACTIVE':
        return SotyState.ACTIVE;

      default:
        return '';
    }
  }, [campaignBanners.active]);

  return sotyState;
};
